import script from "./BaseLoading.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseLoading.vue?vue&type=script&lang=ts&setup=true"

import "./BaseLoading.vue?vue&type=style&index=0&id=fdb4bfb2&lang=css"

const __exports__ = script;

export default __exports__